import { fetcher } from "../api/fetcher";
import { roomState } from "../states/room";

export function adminChangeMicroState(userId: string) {
    fetcher.post({
      path: "/active-room/mute",
      payload: {
        user_id: userId,
        room_id: roomState.id,
      },
    })
    .catch(() => {
    });
}
